const FEATURE_FLAGS = {
  articleCardList: 'articleCardList',
  brandHeader: 'brandHeader',
  brandTitleBar: 'brandTitleBar',
  comments: 'comments',
  containedSearch: 'containedSearch',
  header: 'header',
  infoCardList: 'infoCardList',
  likeButton: 'likeButton',
  mediaCardList: 'mediaCardList',
  newsletterSubscription: 'newsletterSubscription',
  recommendationList: 'recommendationList',
  popularRecommendationList: 'popularRecommendationList',
  popularByBrandRecommendationList: 'popularByBrandRecommendationList',
  sterBanner: 'sterBanner',
  subNavigation: 'subNavigation',
  topBar: 'topBar',
  brandNavigation: 'brandNavigation',
};

export default FEATURE_FLAGS;
